// @flow

import React from 'react';
import { Grid, Container } from '@material-ui/core/';
import DocsMenu from '../../components/docs/menu/menu-expansion';
import Introduction from './introduction';
import OldVersion from './Version4.0';
import CurVersion from './currentversion';
import { useParams } from 'react-router-dom';
import './style.css';

function Intro(props) {
    const { location, scroll } = props;

    const { DocsPageName } = useParams();

    const page = location.state
        ? location.state.page
        : DocsPageName
            ? DocsPageName
            : 'Introduction';
    const [selectedMenu, setSelectedMenu] = React.useState(page);

    const onMenuLinkClick = (event, item) => {
        setSelectedMenu(item);
    };

    const BreadCumVersionLookupclick = (e) => {
        if (e) e.preventDefault();
        setSelectedMenu('version4-taxsoftware');
    };
    const BreadCumVersionActionclick = (e) => {
        if (e) e.preventDefault();
        setSelectedMenu('version4-createbinder');
    };
    const BreadCumVersionAuthclick = (e) => {
        if (e) e.preventDefault();
        setSelectedMenu('version4-gettoken');
    };

    const BreadCumCurVersionLookupclick = (e) => {
        if (e) e.preventDefault();
        setSelectedMenu('currentver-taxsoftware');
    };
    const BreadCumCurVersionActionclick = (e) => {
        if (e) e.preventDefault();
        setSelectedMenu('currentver-createbinder');
    };
    const BreadCumCurVersionAuthclick = (e) => {
        if (e) e.preventDefault();
        setSelectedMenu('currentver-gettoken');
    };
    const onBreadCumCurrentBillingClick = (e) => {
        if (e) e.preventDefault();
        setSelectedMenu('currentver-accountusagehistory');
    };

    const BreadCumVersionListsclick = (e) => {
        if (e) e.preventDefault();
        setSelectedMenu('version4-unclearednotes');
    };
    const BreadCumCurVersionListsclick = (e) => {
        if (e) e.preventDefault();
        setSelectedMenu('currentver-unclearednotes');
    };
    const onBreadCumCurrentnotificationclick = (e) => {
        if (e) e.preventDefault();
        setSelectedMenu('currentver-pushengagementstatus');
    };
    const onBreadCumCurrentTaxCaddyClick = (e) => {
        if (e) e.preventDefault();
        setSelectedMenu('currentver-createclient');
    };

    return (
        <Container className="docs">
            <Grid container>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={4}
                    lg={4}
                    className="menu-container"
                >
                    {/* <Typography component="div" className="doc-search">
                        <QuickSearch />
                    </Typography>*/}
                    <Grid className="doc-side-nav">
                        <DocsMenu
                            selectedItem={selectedMenu}
                            onMenuClick={onMenuLinkClick}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={8} sm={8} md={8} lg={8}>
                    {selectedMenu === 'Introduction' ? (
                        <Introduction scroll={scroll} />
                    ) : selectedMenu.split('-')[0] === 'currentver' ? (
                        <CurVersion
                            PageName={selectedMenu}
                            BreadCumVersionLookupclick={
                                BreadCumCurVersionLookupclick
                            }
                            BreadCumVersionActionclick={
                                BreadCumCurVersionActionclick
                            }
                            BreadCumVersionAuthclick={
                                BreadCumCurVersionAuthclick
                            }
                            BreadCumCurVersionListsclick={
                                BreadCumCurVersionListsclick
                            }
                            onBreadCumCurrentnotificationclick={
                                onBreadCumCurrentnotificationclick
                            }
                            onBreadCumCurrentBillingClick={
                                onBreadCumCurrentBillingClick
                            }
                            onBreadCumCurrentTaxCaddyClick={
                                onBreadCumCurrentTaxCaddyClick
                            }
                        />
                    ) : (
                        <OldVersion
                            PageName={selectedMenu}
                            BreadCumVersionLookupclick={
                                BreadCumVersionLookupclick
                            }
                            BreadCumVersionActionclick={
                                BreadCumVersionActionclick
                            }
                            BreadCumVersionAuthclick={BreadCumVersionAuthclick}
                            BreadCumVersionListsclick={
                                BreadCumVersionListsclick
                            }
                        />
                    )}
                </Grid>
            </Grid>
        </Container>
    );
}

export default Intro;
